/**
 * The relationship between Registration parties.
 * tag: 517
 * @readonly
 * @enum {string} (char)
 */
export enum OwnershipType {
  /** Joint Investors */
  JointInvestors = 'J',
  /** Tenants in Common */
  TenantsInCommon = 'T',
  /** Joint Trustees */
  JointTrustees = '2',
}
